<template>
  <el-select
    v-model="dataPermissionVal"
    filterable
    multiple
    placeholder="请选择"
    size="small"
    @change="getDataRoles"
    @visible-change="visibleChange"
    collapse-tags
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="聚合应用" name="first" :disabled="!comprehensiveArr.length">
        <el-option v-for="item in comprehensiveArr" :key="item.roleId" :label="item.roleName" :value="item.roleId"> </el-option>
      </el-tab-pane>
      <el-tab-pane label="追踪应用" name="second" :disabled="!polymerization.length">
        <el-option v-for="item in polymerization" :key="item.roleId" :label="item.roleName" :value="item.roleId"> </el-option>
      </el-tab-pane>
    </el-tabs>
  </el-select>
</template>
<script>
export default {
  name: 'dataPermission',
  props: ['dataPermissionData', 'itemData'],
  data() {
    return {
      activeName: 'first',
      dataPermissionVal: [],
      comprehensiveArr: [],
      polymerization: [],
      dataRolesArr: [],
      submitDataRoles: [],
      isActivePoly: true,
      isActive: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    visibleChange(isShow) {
      if (isShow) {
        const dom = document.querySelector('.el-tabs__active-bar')
        dom.style.transform = 'translateX(0px)'
        this.activeName = 'first'
      }
    },
    getData() {
      // 编辑选择
      const tabSelectData = JSON.parse(JSON.stringify(this.dataPermissionData))
      this.dataRolesArr = tabSelectData
      tabSelectData.forEach((item) => {
        if (item.authorityType === 3) {
          this.comprehensiveArr.push(item)
        }
        if (item.authorityType === 1) {
          this.polymerization.push(item)
        }
      })
      // 回显数据权限
      const editItemData = JSON.parse(JSON.stringify(this.itemData))
      this.dataPermissionVal = editItemData.dataRoles.map((i) => i.roleId)
      const roleId = editItemData.dataRoles.map((i) => i.roleId)
      this.getDataRoles(roleId)
    },
    getDataRoles(info) {
      this.submitDataRoles = []
      info.forEach((item) => {
        this.dataRolesArr.forEach((ite) => {
          if (item === ite.roleId) {
            this.submitDataRoles.push({
              roleId: item,
              roleName: ite.roleName
            })
          }
        })
      })
      this.$emit('getDataRoles', this.submitDataRoles)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-tabs__header) {
  padding: 0 10px;
  .el-tabs__active-bar {
    width: 56px !important;
  }
}
:deep(.el-select__tags-text) {
  display: inline-block;
  max-width: 130px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:deep(.el-select__tags-text + i) {
  vertical-align: super;
}
</style>
